import cx from "classnames";
import React from "react";

import { BasicButton, ButtonType } from "@gaming/xds-react-js";

import { useProgramColorPicker } from "../../helpers/useProgramColorPicker";
import { ExternalLinkIcon } from "../icons";
import * as styles from "./DevResource.module.css";

export interface DevResourceItem {
  title: string;
  url: string;
}

interface DownloadWidgetProps {
  item: DevResourceItem;
}

export const DevResource = ({ item: { title, url } }: DownloadWidgetProps) => {
  const openFile = () => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) {
      newWindow.opener = null;
    }
  };
  const colorStyle = useProgramColorPicker();

  return (
    <BasicButton
      as={"button"}
      className={styles.buttonContainer}
      onClick={openFile}
      onKeyDown={e => e.key === "Enter" && openFile()}
      buttonType={ButtonType.Primary}
      tabIndex={0}
      role="link"
    >
      <ExternalLinkIcon />
      <div className={cx(styles.titleItem, colorStyle)}>{title}</div>
    </BasicButton>
  );
};
